<!-- one line when there is room, else the amount moves below the used time -->
<div class="flex flex-wrap gap-x-1">
    <span class="whitespace-nowrap">{{ usedSeconds | secondsToHoursMinutes }}</span>
    <span class="whitespace-nowrap text-muted-color">/ {{ budgetHours }}h</span>
</div>
<div class="time-budget-track">
    <div class="time-budget-fill" [class.over]="over" [style.width.%]="percent"></div>
</div>
